<template>
  <div class="container">
    <div class="_inner_center_1200">
      <div class="title">你知道的企业都在用</div>

      <div class="logo-list">
        <div class="logo"
             :class="{ 'ON': index  == swiperOption.initialSlide }"
             v-for="(item,index) in 11"
             @mouseover.stop="toggleSwiper(index)"
             @click.stop="toggleSwiper(index)"
        >
          <img :src="BASE_IMG_UPLOAD + 'enterprise/case/logo' + (index+1) + '.png?v=2'" alt="">
        </div>
      </div>

      <div class="swiper-box">
        <div
          v-swiper:mySwiper="swiperOption"
          class="swiper">
          <div class="swiper-wrapper">
            <div
              v-for="(vo,idx) in 11"
              :key="idx"
              class="swiper-slide _pointer"
            >
              <a
                :href="vo.link_url"
                target="_blank"
                :title="vo.title"
              >
                <img
                  :src="BASE_IMG_UPLOAD+ 'enterprise/case/b' + (idx+1) + '.png'" alt=""
                  class="swiper-img">
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-group">
        <a :href="ENTERPRISE_CASE" target="_blank" class="btn btn-1">查看更多企业案例</a>
        <a :href="PAY_COMPANY" target="_blank" class="btn btn-2"
           @click="tag('充值:企业案例授权:图片');"
        >获取版权保障</a>
      </div>
    </div>

  </div>
</template>

<script>
import {BASE_IMG_UPLOAD, ENTERPRISE_CASE} from "@/constant/_constant/CON_BASIC";
import {PAY_COMPANY} from "@/constant/PATH";
import {tag} from "@/utils/statUtil";

const logoArr = [
  'enterprise/case/logo1.png'
]
export default {
  name: "IntroduceCompanyCase",
  data() {
    return {
      BASE_IMG_UPLOAD,
      index: 0,
      ENTERPRISE_CASE,
      PAY_COMPANY,

      swiperOption: {
        autoplay: {
          delay: 3000,
          speed: 500,
          disableOninteraction: true
        },
        //配置分页
        pagination: {
          // el: '.swiper-pagination'//分页的dom节点
        },
        direction: "horizontal",
        initialSlide: 0, // 默认选中
        loop: true, // 在此无效？？？？？
        centeredSlides: true, //活动块居中
        slideToClickedSlide: false, // 点击切换
        lazy: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        on: {
          slideChange: () => {
            const c_swiper = document.getElementsByClassName("swiper");
            this.swiperOption.initialSlide = c_swiper[0].swiper.activeIndex - 1;
            // this.swiperOption.initialSlide = c_swiper[0].swiper.activeIndex - 1;
            // console.log("轮播图滚动事件 --->",c_swiper[0].swiper.activeIndex)
            if (c_swiper[0].swiper.activeIndex - 1 > 10) {
              this.swiperOption.initialSlide = 0
            }
            if (c_swiper[0].swiper.activeIndex - 1 < 0) {
              this.swiperOption.initialSlide = 10
            }
          }
        }
      },

    }
  },
  methods: {
    toggleSwiper(index) {
      console.log(index)
      // this.calendarMenuIndex = index;

      if (index > 10) {
        index = 0
      }
      if (index < 0) {
        index = 10;
      }
      this.swiperOption.initialSlide = index;
      if (process.client) {
        this.mySwiper.slideTo(index + 1, 1000);
      }
    },
    tag(stat) {
      tag(stat)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 856px;

  ._inner_center_1200 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .title {
    height: 46px;
    font-size: 32px;
    font-weight: bold;
    color: #FFD0AC;
    line-height: 43px;
    letter-spacing: 1px;
    margin: 56px 0 32px;
  }

  .logo-list {
    display: flex;
    align-items: center;
    margin-bottom: 35px;

    .logo {
      width: 60px;
      height: 60px;
      margin-right: 32px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &.ON {
        img {
          //width: 72px;
          //height: 72px;
          transform: scale(1.2);
          border: 2px solid #FBD781;
          box-sizing: border-box;
        }
      }

      img {
        display: inline-block;
        width: 100%;
        height: 100%;
        transition: all 0.4s ease-in-out;
        border-radius: 50%;
        box-shadow: 0px 2px 10px 0px rgba(0,0,26,0.06);
        position: relative;
        border: 2px solid transparent;
        box-sizing: border-box;
      }
    }
  }

  .swiper-box {
    width: 900px;
    height: 504px;
    box-sizing: border-box;
    margin-bottom: 31px;

    .swiper-img {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }

  .btn-group{
    display: flex;

    .btn{
      width: 220px;
      height: 54px;
      line-height: 54px;
      text-align: center;
      border-radius: 27px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }

    .btn-1{
      border: 1px solid #6969FF;
      background: #FFFFFF;
      color: #6969FF;
      box-sizing: border-box;
      margin-right: 48px;
    }
    .btn-2{
      background: rgba(105, 105, 255, 1);
      color: #FFFFFF;
    }
  }

  .card-bg{

  }
}
</style>
